<template>
    <v-app>
        <div class="page-container">
            <div class="navbar-container">
                <Navbar title="Checkout" :show-language-button="false" :show-back-button="true" />
            </div>
            <v-container class="main-container">
                <v-card elevation="2" class="rounded-lg mb-8">
                    <div class="d-flex align-start justify-start">
                        <v-avatar class="ma-3 rounded-lg" size="90" tile>
                            <v-img :src="storeData?.logo" style="border-radius: 50px;"></v-img>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <v-card-title class="pb-2 font-weight-bold">{{ storeData?.name }}</v-card-title>
                            <v-card-text>
                                <v-chip class="rounded-lg">
                                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" class="mr-2"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M12 13.6668H2C1.196 13.6668 0 13.1342 0 11.6668V10.3335V8.3335V4.3335V2.3335C0 0.866163 1.196 0.333496 2 0.333496H10.6667C11.402 0.333496 12 0.931496 12 1.66683V9.00016V10.3335V11.0002H11.3333H10.6667H2.008C1.7 11.0082 1.33333 11.1302 1.33333 11.6668C1.33333 12.2035 1.7 12.3255 2.008 12.3335H12V13.6668ZM1.33333 2.3335V4.3335V8.3335V9.66683H10.6667V9.00016V1.66683H2C1.7 1.67483 1.33333 1.79683 1.33333 2.3335ZM9.33333 3.00016H3.33333V4.3335H9.33333V3.00016Z"
                                            fill="#272727" />
                                    </svg>
                                    {{ $t('text_reservation') }}
                                </v-chip>
                            </v-card-text>
                        </div>
                    </div>
                </v-card>

                <v-card elevation="2" class="rounded-lg mb-4">
                    <div class="d-flex flex-column">
                        <div v-for="(item, index) in cartReservations" :key="index" :style="findInvalidOrder(item) ? 'border: 2px solid red' : ''">
                            <div class="d-flex align-center justify-space-between px-4 py-2 pb-0">
                                <span class="font-weight-medium" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important' : ''">{{ item.name }}</span>
                                <v-spacer />
                                <v-btn v-if="cartReservations.length > 1" color="error" icon @click="removeItem(item)">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="22" width="22"
                                        viewBox="0 0 24 24">
                                        <path
                                            d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
                                    </svg>
                                </v-btn>
                            </div>
                            <div class="d-flex justify-start">
                                <v-avatar class="ma-3 rounded-lg mt-0" size="90" tile>
                                    <v-img style="border-radius: 10px;" :style="findInvalidOrder(item) ? 'filter: grayscale(1)' : ''"
                                        :src="item.item_place_reservation?.photo_md"></v-img>
                                </v-avatar>
                                <v-card-text class="d-flex flex-column pl-0 pt-0">
                                    <span v-if="item.item_place_reservation"
                                        class="d-flex align-center font-weight-regular" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important' : ''">
                                        <svg class="mr-2" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                                                fill="currentColor" />
                                        </svg>
                                        {{ item.item_place_reservation?.capacity ?? '-' }} {{ $t('text_persons') }}
                                    </span>
                                    <span class="d-flex align-center font-weight-regular" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important' : ''">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="14" height="14"
                                            class="mr-2" viewBox="0 0 24 24">
                                            <path
                                                d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z" />
                                        </svg>
                                        {{ item?.reservation_date?.fdate }}
                                    </span>
                                    <div class="d-flex align-center font-weight-regular">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                            class="mr-2" viewBox="0 0 24 24">
                                            <path  fill="currentColor"
                                                d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
                                        </svg>
                                        <span :style="findInvalidOrder(item) ? 'color: #cbcbcb!important' : ''">{{ item.reserve_time }}</span>
                                        <span class="ml-2 blue--text font-weight-bold" style="cursor: pointer;" :style="findInvalidOrder(item) ? 'display: none!important;' : ''"
                                            @click="changeTimeReservation(item)">{{ $t('text_change') }}</span>
                                    </div>
                                    <div class="price mt-1" style="font-size: 1rem;" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important;' : item?.special_price?.with_special_price === 1 ? 'color: #7b7b7b!important;text-decoration: line-through' : ''">
                                        {{ item?.item_place_reservation?.fprice ?? '-' }}
                                    </div>
                                    <div v-if="item?.special_price?.with_special_price === 1" class="price" style="font-size: 1rem;" :style="findInvalidOrder(item) ? 'color: #cbcbcb!important' : ''">
                                        {{ item?.special_price?.fspecial_price ?? '-' }}
                                    </div>
                                </v-card-text>
                            </div>
                            <v-card-text v-if="findInvalidOrder(item)" style="color: red;font-size: 12px;padding-top: 2px;">{{ findInvalidOrder(item)?.message }}</v-card-text>
                            <v-divider v-if="index < cartReservations.length - 1" class="mx-3"></v-divider>
                        </div>
                    </div>
                </v-card>

                <v-card v-if="isNotValidCustomer" elevation="2" class="rounded-lg mb-6" style="background-color: #FFF2E3;">
                    <div class="d-flex justify-space-between align-center my-0 px-8">
                        <svg class="mr-2" width="50" height="50" viewBox="0 0 17 17" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                                fill="#767676" />
                        </svg>
                        <div class="d-flex flex-column px-2 py-2">
                            <v-card-title class="px-0 py-0">{{ $t('text_you_are_not_logged_in') }}</v-card-title>
                            <v-card-text class="px-0 py-0 text-caption">{{ $t('text_login_to_continue') }}</v-card-text>
                        </div>
                        <v-btn color="primary" class="font-weight-bold" text @click="handleLogin">Login</v-btn>
                    </div>
                </v-card>

                <v-card v-if="!isNotValidCustomer" elevation="2" class="rounded-lg mb-6">
                    <div class="d-flex flex-column my-0 px-2">
                        <div class="d-flex justify-start align-center">
                            <v-avatar class="ma-3 rounded-lg" tile>
                                <v-img :src="getCustomerData?.avatar_img_path" style="border-radius: 50px;"></v-img>
                            </v-avatar>
                            <div class="d-flex flex-column px-2 py-2">
                                <v-card-text class="px-0 py-0 font-weight-bold">{{ getCustomerData?.name }}</v-card-text>
                                <v-card-text class="px-0 py-0 text-caption">{{ getCustomerData?.email }}</v-card-text>
                            </div>
                        </div>
                        <div role="alert" class="v-alert v-sheet theme--dark v-alert--text info--text">
                            <div class="v-alert__wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    class="v-icon notranslate v-alert__icon mdi mdi-information-outline theme--dark info--text"
                                    fill="currentColor" viewBox="0 0 24 24">
                                    <path
                                        d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
                                </svg>
                                <div class="v-alert__content"> {{ $t('text_bukti_transaksi_akan_dikirimkan_ke_email_anda') }} </div>
                            </div>
                        </div>
                    </div>
                </v-card>

                <div class="payment-detail">
                    <span class="font-weight-bold">{{ $t('text_price') }}</span>
                    <div class="d-flex justify-space-between align-center mt-2">
                        <span class="font-weight-medium">Subtotal</span>
                        <v-spacer />
                        <span class="font-weight-medium">{{ formatCurrency(subTotalReservationPrice, true) }}</span>
                    </div>
                    <div class="d-flex justify-space-between align-center mt-2">
                        <span class="font-weight-medium">{{ $t('text_admin_fee') }}</span>
                        <v-spacer />
                        <span class="font-weight-medium">{{ formatCurrency(adminFee, true) }}</span>
                    </div>
                    <!-- <div class="d-flex justify-space-between align-center mt-2">
                        <span class="font-weight-medium">Tax</span>
                        <v-spacer />
                        <span class="font-weight-medium">{{ formatCurrency(reservationTax, true) }}</span>
                    </div> -->
                    <div class="d-flex justify-space-between align-center mt-8">
                        <span class="font-weight-medium">Total</span>
                        <v-spacer />
                        <span class="font-weight-medium">{{ formatCurrency(totalReservationPrice, true) }}</span>
                    </div>
                </div>


                <div class="btn-nav-footer">
                    <v-btn color="success" :elevation="0" class="btn-submit font-weight-bold" :disabled="getLoadingAxiosState || isNotValidCustomer"
                        @click="handleCheckout">
                        {{ $t('text_pay') }} ({{ formatCurrency(totalReservationPrice, true) }})
                    </v-btn>
                </div>

            </v-container>



            <v-bottom-sheet v-model="sheetForSeat" inset max-width="480px">
                <v-sheet class="px-3 py-2 sheet" :style="windowHeight < 573 ? 'height: 80vh; overflow-y: scroll' : ''" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
                    <div class="sheet-content">
                        <div class="time-layout-duration" style="display: block;">
                            <img :src="selectedReservation?.item_place_reservation?.photo_md" alt=""
                                style="width: 100%;height: 200px;object-fit: cover;margin: 0 auto;border-radius: 15px;" />
                        </div>
                        <div class="d-flex align-center justify-space-between">
                            <span class="d-flex align-center" style="font-weight: 700;">
                                <svg class="mr-1" width="14" height="11" viewBox="0 0 14 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M1.9981 0.166687C1.34647 0.166687 0.790305 0.637677 0.682974 1.2804L0.348987 3.2804C0.213248 4.09324 0.840021 4.83335 1.66411 4.83335H2.71382V10.3426C2.71382 10.6137 2.93352 10.8334 3.20453 10.8334C3.44967 10.8334 3.6572 10.6525 3.69066 10.4096L4.09151 7.50002H9.90845L10.3093 10.4096C10.3428 10.6525 10.5503 10.8334 10.7954 10.8334C11.0664 10.8334 11.2861 10.6137 11.2861 10.3426V4.83335H12.3358C13.1599 4.83335 13.7867 4.09324 13.651 3.2804L13.317 1.2804C13.2097 0.637678 12.6535 0.166687 12.0019 0.166687H1.9981ZM9.72476 6.16669L9.5536 4.92434C9.54938 4.89371 9.54731 4.86334 9.54725 4.83335H4.45272C4.45266 4.86333 4.45058 4.89371 4.44636 4.92434L4.27521 6.16669H9.72476ZM1.9981 1.50002L12.0019 1.50002L12.3358 3.50002L1.66411 3.50002L1.9981 1.50002Z"
                                        fill="#767676" />
                                </svg>
                                {{ selectedReservation?.name }}
                            </span>
                            <span v-if="selectedReservation?.item_place_reservation" class="d-flex align-center"
                                style="font-weight: 700;">
                                <svg class="mr-1" width="17" height="17" viewBox="0 0 17 17" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.66663 1.83331C6.82863 1.83331 5.33329 3.32865 5.33329 5.16665C5.33329 7.00465 6.82863 8.49998 8.66663 8.49998C10.5046 8.49998 12 7.00465 12 5.16665C12 3.32865 10.5046 1.83331 8.66663 1.83331ZM8.66663 7.16665C7.56396 7.16665 6.66663 6.26931 6.66663 5.16665C6.66663 4.06398 7.56396 3.16665 8.66663 3.16665C9.76929 3.16665 10.6666 4.06398 10.6666 5.16665C10.6666 6.26931 9.76929 7.16665 8.66663 7.16665ZM14.6666 14.5V13.8333C14.6666 11.2606 12.5726 9.16665 9.99996 9.16665H7.33329C4.75996 9.16665 2.66663 11.2606 2.66663 13.8333V14.5H3.99996V13.8333C3.99996 11.9953 5.49529 10.5 7.33329 10.5H9.99996C11.838 10.5 13.3333 11.9953 13.3333 13.8333V14.5H14.6666Z"
                                        fill="#767676" />
                                </svg>
                                {{ selectedReservation?.item_place_reservation?.capacity ?? '-' }} {{ $t('text_persons') }}
                            </span>
                        </div>

                        <div class="price blue--text font-weight-large mt-1" style="font-weight: 700;" :style="selectedReservation?.special_price?.with_special_price === 1 ? 'color: #7b7b7b!important;text-decoration: line-through' : ''">
                            {{ selectedReservation?.item_place_reservation?.fprice ?? "-" }}
                          </div>
                          <div v-if="selectedReservation?.special_price?.with_special_price === 1" class="price blue--text font-weight-large" style="font-weight: 700;">
                            {{ selectedReservation?.special_price?.fspecial_price ?? "-" }}
                          </div>
                        <div class="description d-flex flex-column mt-2">
                            <span class="text-bold" style="font-weight: 700;">{{ $t('text_description') }}</span>
                            <!-- <span class="text-caption">{{ selectedReservation?.item_place_reservation?.notes ?? '-'
                            }}</span> -->
                        <template>
                            <div class="deskripsi" style="max-height: 75px;overflow-y: scroll;">
                            <span v-if="selectedReservation?.item_place_reservation?.notes?.length > 110 && !readMoreActivated" class="text-captio">{{ selectedReservation?.item_place_reservation?.notes?.slice(0, 110) }}... </span>
                            <a class="text-captio" style="text-decoration: none;" v-if="selectedReservation?.item_place_reservation?.notes?.length > 110 && !readMoreActivated" @click="activateReadMore" href="#">
                                Read more
                            </a>
                            <span v-else class="text-captio" v-html="selectedReservation?.item_place_reservation?.notes ?? '-'"></span>
                            <a class="text-captio" style="text-decoration: none;" v-if="readMoreActivated" @click="activateReadMore" href="#">
                                Read less...
                            </a>
                            </div>
                        </template>
                        </div>
                        <v-divider class="my-2"></v-divider>
                        <div class="time-option">
                            <div class="text-bold" style="font-weight: 700;"><v-icon class="mr-1"
                                    size="30">mdi-calendar-month</v-icon>{{
                                        selectedReservation?.reservation_date?.fdate }}
                            </div>
                            <span class="text-bold" style="font-weight: 700;">{{ $t('text_select_visit_time') }}</span>
                            <div class="time-picker mt-2">
                                <div class="d-flex justify-space-between reservasi_picker align-center" style="gap: 10px;">
                                    <div class="d-flex flex-column w-100" style="width: 100%;">
                                        <span style="font-size: small;">{{ $t('text_hours') }}</span>
                                        <vue-timepicker v-model="hour_selected" close-on-complete :hour-range="range_hour"
                                            @change="hourChange" format="HH" :hour-label="$t('text_hours')" :placeholder="$t('text_hours')"
                                            input-class="time_picke" input-width="100%" drop-direction="auto"
                                            auto-scroll></vue-timepicker>
                                    </div>
                                    <span>:</span>
                                    <div class="d-flex flex-column w-100" style="width: 100%;">
                                        <span style="font-size: small;">{{ $t('text_minutes') }}</span>
                                        <vue-timepicker v-model="minute_selected" :minute-interval="1" close-on-complete
                                            :minute-range="range_minute" format="mm" :minute-label="$t('text_minutes')"
                                            :placeholder="$t('text_minutes')" @change="minuteChange" input-class="time_picke"
                                            input-width="100%" drop-direction="auto" auto-scroll></vue-timepicker>
                                    </div>
                                </div>
                                <div class="btn-booking mt-4">
                                    <v-btn color="success" style="width: 100%;" :elevation="0" @click="toggleSeatSelection"
                                        :disabled="(!hour_selected.HH || !minute_selected.mm) || !isCartLength">{{ $t('text_booking') }}</v-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-sheet>
            </v-bottom-sheet>

        </div>
    </v-app>
</template>

<script>
import Navbar from "@/components/Layouts/Navbar.vue";
import { checkreservationAvailability, checkSpecialPrice } from "@/api/reservation-time";
import { mapGetters } from "vuex";
import { formatCurrency } from "@/utils/currencyUtils";
import { customerData } from "@/api/auth";
import { setQueryParam } from '@/utils/customQuery'
export default {
    name: "Checkout",
    components: {
        Navbar
    },
    data() {
        return {
            serveStatus: process.env.VUE_APP_SERVE,
            selectedReservation: null,
            sheetForSeat: false,
            timeSelected: null,
            reserveTime: [],
            range_hour: [],
            range_minute: null,
            hour_selected: {
                HH: null
            },
            minute_selected: {
                mm: null
            },
            readMoreActivated: false,
            invalid_order: [],
            windowHeight: window.innerHeight,
        }
    },

    watch: {
        sheetForSeat(newVal) {
            if (!newVal) {
                this.timeSelected = null
                this.hour_selected.HH = null
                this.minute_selected.mm = null
            }
        },
        timeSelected(newTime) {
            if (!`${newTime}`.includes('null')) {
                setTimeout(() => {
                    this.getSpecialPrice(newTime)
                }, 500);
            }
        }
    },

    mounted() {
        setTimeout(() => {
            const listCart = this.$store.getters.dataCartReservation ?? []
            if (listCart.length > 0) {
                this.checkAvailability({
                    callback: (data) => {}
                })
            }
        }, 1000);

        this.$nextTick(() => {
        window?.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
    window?.removeEventListener('resize', this.onResize); 
    },

    computed: {
        storeData() {
            return this.$store.getters.getStoreData;
        },
        cartReservations() {
            return this.$store.getters.dataCartReservation;
        },
        isCartLength() {
            return this.cartReservations.length;
        },
        isNotValidCustomer() {
            const authData = JSON.parse(localStorage.getItem('olselforder_auth_data'))
            return this.$store.getters.getAuthData?.auth_by === 'SYSTEM' || authData?.auth_by === 'SYSTEM'
        },
        ...mapGetters(["subTotalReservationPrice", "adminFee", "reservationTax", "totalReservationPrice", "getCustomerData", "getLoadingAxiosState", "getUrlDomain"]),
    },
    methods: {
        onResize() {
        this.windowHeight = window.innerHeight
        },
        findInvalidOrder(item) {
            return this.invalid_order.find(
                (invalid) => parseInt(invalid.layout_item_id) === item.id
            )
        },
        activateReadMore(){
            this.readMoreActivated = !this.readMoreActivated
        },
        // async fetchCustomerData(isAuth) {
        //     if (isAuth) {
        //         try {
        //             const { data } = await customerData().then(res => res.data)
        //             this.$store.dispatch('saveCustomerData', data)
        //         } catch (error) {
        //             this.$store.state.show_error = true
        //             this.$store.state.error_message = error.data.error
        //             this.$store.state.error_type = error.data.status_code
        //         } finally {
        //             this.$store.state.loading_axios = false
        //         }
        //     }
        // },
        hourChange(newHour) {
            const { HH } = newHour.data;
            if (HH && HH !== "") {
                const hour = String(HH).padStart(2, '0')
                const minutes = this.cariMenitBerdasarkanJam(this.reserveTime, hour)
                this.timeSelected = `${HH}:${this.minute_selected.mm}`
                if (minutes.length) {
                    // this.range_minute = [[...minutes, 59]]
                    this.minute_selected.mm = `${String(minutes[0]).padStart(2, '0')}`
                } else {
                    this.minute_selected.mm = null
                    this.range_minute = null
                }
            } else {
                this.timeSelected = null
                this.minute_selected.mm = null
            }
        },
        minuteChange(newMinute) {
            const { mm } = newMinute.data;
            if (mm && mm !== "" && this.hour_selected.HH !== "") {
                const time = `${this.hour_selected.HH}:${mm}`
                this.timeSelected = time;
            } else {
                this.timeSelected = null
            }
        },
        async getSpecialPrice(time) {
            // if (["allinolsera2", "infinitybeachclub", "jakartatest"].includes(this.getUrlDomain) && this.serveStatus === "staging") {
            if (["infinitybeachtest",'infinitybeachclub'].includes(this.getUrlDomain)) {
                try {
                    const { data } = await checkSpecialPrice({
                        reserve_date: this.selectedReservation?.reservation_date?.date,
                        reserve_time: time,
                        item_place_reservation_id: this.selectedReservation.item_place_reservation.id
                    }).then(res => res.data);
                    this.selectedReservation = { ...this.selectedReservation, special_price: data }
                } catch (e) {
                    console.log('error', e);
                    this.$store.state.show_error = true
                    this.$store.state.error_message = e.data.message
                    this.$store.state.error_type = e.statusCode
                }
            }
        },
        cariMenitBerdasarkanJam(data, jamYangDicari) {
            function getMinutesFromTime(time) {
                const parts = time.split(":");
                if (parts.length === 2) {
                    return parseInt(parts[1], 10);
                }
                return null;
            }

            const menitYangDicari = data.map(item => {
                if (item.fstart_time.startsWith(jamYangDicari)) {
                    return getMinutesFromTime(item.fstart_time);
                }
                if (item.fend_time.startsWith(jamYangDicari)) {
                    return getMinutesFromTime(item.fend_time);
                }
                return null;
            });

            return menitYangDicari.filter(menit => menit !== null);
        },
        formatCurrency,
        removeItem(item) {
            this.$store.dispatch("removeItemReservation", item);
        },
        changeTimeReservation(item) {
            this.selectedReservation = item;
            this.sheetForSeat = true;

            const allTime = item?.reservation_date?.times;
            const mapTime = allTime
                // .filter((item) => item.can_not_be_used !== 1)
                .map(item => {
                    const startTimeParts = item.fstart_time.split(':');
                    const endTimeParts = item.fend_time.split(':');
                    const startHour = parseInt(startTimeParts[0]);
                    const endHour = parseInt(endTimeParts[0]);
                    return [startHour, endHour];
                });

            this.reserveTime = allTime
            this.range_hour = mapTime
            this.hour_selected.HH = item.hour
            setTimeout(() => {
                this.minute_selected.mm = item.minute
            }, 200);
        },
        async toggleSeatSelection() {
            this.$store.state.loading_axios = true
            try {
                const { data } = await checkreservationAvailability({
                    reserve_date: this.selectedReservation?.reservation_date?.date,
                    reserve_time: this.timeSelected,
                    layout_item_id: this.selectedReservation.id
                }).then(res => res.data);
                if (data) {
                    const reservationData = [{
                        ...this.selectedReservation,
                        reserve_time: this.timeSelected,
                        hour: this.hour_selected.HH,
                        minute: this.minute_selected.mm,
                    }]
                    this.$store.dispatch("addItemReservation", reservationData);
                    this.sheetForSeat = false;
                }
            } catch (e) {
                console.log('error', e);
                this.$store.state.show_error = true
                this.$store.state.error_message = e.res?.data?.message ?? e.res?.error?.message
                this.$store.state.error_type = e.res?.status
            } finally {
                this.$store.state.loading_axios = false
            }
        },
        handleLogin() {
            // this.$router.push('/login')
            // window.location.href = '/login'
            window.location.replace('/login')
        },
        async checkAvailability ({ callback = () => {} }) {
            this.$store.state.loading_axios = true
            const dataCart = this.cartReservations.map((item) => ({
                reserve_date: item.reservation_date.date,
                reserve_time: item.reserve_time,
                layout_item_id: item.id
            }))
            try {
                const { data } = await checkreservationAvailability(dataCart).then(res => res.data);
                // update data cart
                data.forEach(item => {
                    const findInCart = this.cartReservations.find((cart) => cart?.item_place_reservation?.id === item.details?.id)
                    const newCart = [{
                        ...findInCart,
                        item_place_reservation: item.details
                    }]
                    this.$store.dispatch("addItemReservation", newCart);
                })

                const invalidData = data.filter(item => item.status !== 200)
                this.invalid_order = invalidData
                if (invalidData.length > 0) {
                    this.$store.state.show_error = true
                    this.$store.state.error_message = invalidData[0].message
                } else {
                    callback(data)
                }
            } catch (e) {
                this.$store.state.show_error = true
                this.$store.state.error_message = e.res?.data?.message ?? e.res?.error?.message
                this.$store.state.error_type = e.res?.status
            } finally {
                this.$store.state.loading_axios = false
            }
        },
        async handleCheckout() {
            this.checkAvailability({
                callback: (data) => {
                    this.$store.dispatch("set_router_data", { name: 'payment' });
                    setQueryParam('page', 'payment')
                }
            })
        }
    }
}
</script>

<style>
/* FILEPATH: /Users/tommy/Documents/dev/olsera/fe-reservation-web-component/src/views/components/Checkout.vue */
/* BEGIN: ed8c6549bwf9 */
.main-container {
    gap: 0 !important;
}

.time-layout-duration {
    display: block;
}

.time-layout-duration img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    margin: 0 auto;
    border-radius: 15px;
}

.btn-booking {
    padding-top: 10px;
}

.btn-booking button {
    width: 100%;
    border-radius: 50px;
}

/* END: ed8c6549bwf9 */</style>